/**
 * 一次「同步更新」点击的去重 id：同一点击下多个平台接口只扣 1 次。
 */

export const SHEIN_MANUAL_SYNC_CLICK_HEADER = 'X-Shein-Manual-Sync-Click';

const TTL_MS = 120000;

let clickId = '';
let expiresAt = 0;

export function beginSheinManualSyncClick() {
  const cryptoApi = typeof window !== 'undefined' ? window.crypto : undefined;
  const raw = (typeof cryptoApi?.randomUUID === 'function')
    ? cryptoApi.randomUUID()
    : `c${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`;
  clickId = String(raw).replace(/[^a-zA-Z0-9_-]/g, '').slice(0, 80);
  if (clickId.length < 8) {
    clickId = `c${Date.now().toString(36)}${Math.random().toString(36).slice(2, 8)}`;
  }
  expiresAt = Date.now() + TTL_MS;
  return clickId;
}

export function currentSheinManualSyncClickId() {
  if (!clickId || Date.now() > expiresAt) return '';
  return clickId;
}

export function parseSheinShopIdFromPath(path) {
  const m = String(path || '').match(/\/shops\/(\d+)\//);
  return m ? m[1] : '';
}
